<script lang="ts">
    import logo from 'src/components/#assets/logo.svg'
    import balanceIcon from 'src/components/#assets/realis-icon.svg'
    import dashboardIcon from 'src/components/cabinet/#assets/dashboard-icon.svg'
    import dashboardOrange from 'src/components/cabinet/#assets/dashboard-orange.svg'
    import marketplaceIcon from 'src/components/cabinet/#assets/marketplace-icon.svg'
    import rightIcon from 'src/components/cabinet/#assets/right-icon.svg'
    import dragIcon from 'src/components/cabinet/#assets/drag.svg'
    import avatarIcon from 'src/components/cabinet/#assets/avatar.svg'
    import marketplaceOrange from 'src/components/cabinet/#assets/marketplace-orange.svg'
    import {Link} from 'svelte-routing'
    import IconifyIcon from '@iconify/svelte'
    import userIcon from '@iconify/icons-fa-solid/user-alt'
    import walletIcon from '@iconify/icons-fa-solid/wallet'
    import heroIcon from '@iconify/icons-fa-solid/street-view'
    import runIcon from '@iconify/icons-fa-solid/running'
    import cogIcon from '@iconify/icons-fa-solid/cog'
    import questionIcon from '@iconify/icons-fa-solid/question-circle'
    import logoutIcon from '@iconify/icons-fa-solid/sign-out-alt'
    import notificationIcon from '@iconify/icons-fa-solid/bell'
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import {userProfile} from 'src/services/auth'
    import {api} from '../../../../services/api/reallis'
    import Menu from '../../../#common/menu/menu.svelte'
    import {userIsAdmin} from 'src/components/main/#services/userRole'

    let notificationsCount = 4
    let mobileMenuOpened = false
    let url = window.location.pathname

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }

    let dashboardLink = ''
    $: if ($userIsAdmin.value && process.env.DASHBOARD_URL) {
        dashboardLink = process.env.DASHBOARD_URL
    }
</script>

<header class="header {mobileMenuOpened ? 'menu-open' : ''}">
    <Link to="/" class="logo" on:click={() => { mobileMenuOpened = false }}>
        <img src="{logo}" class="logotype" width="96" alt="logo">
    </Link>
    <nav class="menu">
        {#if dashboardLink}
        <a href="{dashboardLink}" class="menu-item" target="_blank">
            <div class="menu-icon active">
                <img src="{dashboardIcon}" alt="">
            </div>
            Dashboard
            <div class="circle-icon">
                <img src="{rightIcon}" alt="">
            </div>
        </a>
        {/if}
        <!--
        <Link to="marketplace" class="menu-item">
            <div class="menu-icon active">
                <img src="{marketplaceIcon}" alt="">
            </div>
            Marketplace
            <div class="circle-icon">
                <img src="{rightIcon}" alt="">
            </div>
        </Link>
        -->
    </nav>
    <div class="right-side">
        <!--
        <div class="notification-icon">
            <div class="notifications-count">{notificationsCount}</div>
            <IconifyIcon icon={notificationIcon}/>
        </div>
        -->
        <Link to="activity" class="balance">
            <div class="balance-circle">
                <img src="{dragIcon}" class="balance-icon" alt="">
            </div>
            <span class="notranslate">{!$myBalance.hasValue ? "..." : Math.floor($myBalance.value.data.totalBalance)} DRAG</span>
        </Link>
        <Link to="account" class="user">
            <img src="{avatarIcon}" alt="">
            <!--
            <div class="avatar notranslate">{avatar($userProfile?.nickname || "..")}</div>
            <div class="nickname notranslate">
                <div class="user-nickname">{$userProfile?.nickname || "Account"}</div>
                <div class="user-id">#{$userProfile?.userId || ".........."}</div>
            </div>
            -->
        </Link>
        <Menu template="cabinet"/>
    </div>
</header>

<style>
    .header {
        background: #25234c;
        position: fixed;
        width: 100%;
        height: 90px;
        top: 0;
        left: 0;
        z-index: 5;
        right: 0;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #312d61;
    }

    .header :global(.logo) {
        width: 300px;
        padding: 0 30px;
        display: flex;
        align-items: center;
        height: 100%;
        border-right: 2px solid #353064;
        transition: .2s;
    }

    .header :global(.logo:hover) {
        background: #353064;
    }

    .header :global(.menu-icon) {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 26px;
    }

    .header :global(.menu-icon img) {
        width: 100%;
    }

    .logotype {
        display: block;
        width: 130px;
    }

    .header .menu {
        margin-left: 60px;
        display: flex;
        align-items: center;
    }

    .header :global(.menu-item) {
        font-size: 16px;
        font-weight: 600;
        line-height: 1;
        color: white;
        text-decoration: none;
        display: flex;
        height: 50px;
        align-items: center;
        border-radius: 50px;
        padding: 4px 4px 4px 12px;
        background: #494591;
        box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.3) inset, 0 -1px 1px 0 rgba(0, 0, 0, 0.4) inset;
        transition: .25s;
    }

    .circle-icon {
        width: 42px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #7262FF;
        margin-left: 15px;
        border-radius: 50%;
        box-shadow: 0 -1px 1px 0 rgba(1, 7, 10, 0.3) inset;
        filter: drop-shadow(0 1px 2px rgba(1, 7, 10, 0.3));
    }

    .header :global(.menu-item:not(:first-child)) {
        margin-left: 30px;
    }

    .header :global(.menu-icon.active) {
        border-color: #59598E;
        transition: .25s;
    }

    .header :global(.btn-secondary) {
        margin-right: 8px;
    }

    .notification-icon {
        color: white;
        border: 1px solid #3A3F5D;
        box-sizing: border-box;
        border-radius: 6px;
        width: 40px;
        height: 40px;
        margin: 8px 50px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
    }

    .header .right-side {
        position: absolute;
        right: 90px;
        display: flex;
    }

    .notifications-count {
        height: 20px;
        min-width: 20px;
        background: #FF5D1C;
        color: white;
        border-radius: 10px;
        left: 100%;
        top: -10px;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        padding: 0 6px;
        position: absolute;
        text-align: center;
        transform: translateX(-50%);
    }

    .header :global(.balance) {
        font-size: 16px;
        color: white;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin: 5px 60px 0 0;
        height: 50px;
        line-height: normal;
        text-decoration: none;
        border-radius: 66px;
        border: 1px solid #494591;
        background: #343168;
        padding: 4px 20px 4px 4px;
    }

    .balance-circle {
        width: 42px;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #534FA2;
        margin-right: 15px;
        border-radius: 50%;
        box-shadow: 0 -1px 1px 0 rgba(1, 7, 10, 0.3) inset;
    }

    .header :global(.balance img) {
        width: 40px;
        transition: .2s;
    }

    .header :global(.balance:hover img) {
        filter: contrast(2);
    }

    .header :global(.user) {
        display: flex;
        align-items: center;
        text-decoration: none;
        border-radius: 12px;
        border: 2px solid #F5841F;
        padding: 2px;
        width: 60px;
        height: 60px;
    }

    .header :global(.avatar) {
        background: #2E3549;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
        font-size: 18px;
        font-weight: 500;
        text-transform: uppercase;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .header :global(.nickname) {
        line-height: 20px;
    }

    .header :global(.user-nickname) {
        font-size: 15px;
        font-weight: 500;
        color: white;
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .header :global(.user-id) {
        font-size: 15px;
        color: #61758A;
    }

    .hamburger-btn {
        display: none;
    }

    .hamburger-btn span {
        background: white;
        margin: 10px 0;
        border-radius: 2px;
        display: block;
        height: 2px;
        transition: .25s;
    }

    .hamburger-btn span:nth-child(1) {
        width: 22px;
        margin-left: 10px;
    }

    .hamburger-btn span:nth-child(2) {
        width: 32px;
    }

    .hamburger-btn span:nth-child(3) {
        width: 17px;
        margin-left: 15px;
    }

    .hamburger-menu .hamburger-btn span:nth-child(1) {
        width: 36px;
        transform: rotate(-45deg) translate(-6px, 12px);
    }

    .hamburger-menu .hamburger-btn span:nth-child(2) {
        opacity: 0;
    }

    .hamburger-menu .hamburger-btn span:nth-child(3) {
        width: 36px;
        transform: rotate(45deg) translate(-8px, -8px);
    }

    .hamburger-menu {
        position: fixed;
        width: 270px;
        height: 100%;
        top: 0;
        right: -100%;
        background: #1B262C;
        transition: .5s;
    }

    .hamburger-menu.active {
        right: 0;
    }

    .hamburger-background {
        width: 100%;
        height: 100%;
        position: fixed;
        visibility: hidden;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
        opacity: 0;
        transition: .6s;
    }

    .hamburger-background.active {
        visibility: visible;
        opacity: 1;
    }

    .user-menu {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .user-menu-item :global(.user-menu-link) {
        display: block;
        padding: 10px 5px;
        font-size: 16px;
        color: white;
        margin: 5px 10px;
        position: relative;
        border-radius: 6px;
        text-decoration: none;
        transition: all .4s;
        list-style: none;
    }

    .user-menu-item :global(.user-menu-icon) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: top;
        width: 20px;
    }

    .help-center-item {
        border-top: 1px solid #2E3549;
        margin-top: 8px;
        padding: 15px 0 5px;
    }

    .logout-item .user-menu-link {
        color: #EB5757;
        margin-bottom: 30px;
    }

    .hamburger-menu-overflow {
        overflow: auto;
        height: calc(100vh - 142px);
    }

    @media(max-width: 1400px) {
        .header :global(.balance) {
            margin: 5px 40px 0 0;
        }

        .header .right-side {
            right: 40px;
        }

        .header .menu {
            margin-left: 40px;
        }
    }

    @media(max-width: 1199px) {
        .circle-icon {
            display: none;
        }

        .header :global(.menu-icon) {
            margin-right: 15px;
        }

        .header :global(.menu-item) {
            padding-right: 20px;
        }
    }

    @media(max-width: 992px) {
        .header {
            height: 60px;
        }

        .header :global(.logo) {
            padding: 0 15px;
            border-right: 0;
        }

        .header :global(.logo:hover) {
            background: none;
        }

        .header :global(.balance img) {
            width: 30px;
        }

        .logotype {
            width: 76px;
        }

        .hamburger-btn {
            display: block;
            background: none;
            border: 0;
            padding: 0 7px;
        }

        .hamburger-menu .hamburger-btn {
            position: absolute;
            right: 17px;
            top: 6px;
            padding: 0;
        }

        .header .menu {
            display: none;
        }

        .header .right-side {
            right: 20px;
        }

        .right-side :global(.balance),
        .right-side :global(.user) {
            display: none;
        }

        .right-side :global(.hamburger-menu .balance) {
            display: inline-block;
            margin: 10px 0 0 15px;
            padding: 8px 15px 8px 10px;
            height: 42px;
            font-size: 14px;
        }

        .right-side :global(.hamburger-menu .user) {
            display: flex;
            margin: 10px 15px;
            padding: 15px 0;
            border-top: 1px solid #2E3549;
            border-bottom: 1px solid #2E3549;
        }

        .header .balance img {
            height: 24px;
            width: 24px;
        }

        .header .balance span {
            vertical-align: middle;
        }

        .header .avatar {
            width: 40px;
            height: 40px;
        }

        .header .user-nickname {
            font-size: 14px;
            max-width: 190px;
        }

        .header .user-id {
            font-size: 12px;
            margin-bottom: -2px;
        }

        .header .hamburger-menu .menu {
            display: block;
            margin: 25px 15px;
            border-bottom: 1px solid #2E3549;
        }

        .hamburger-menu .menu-icon {
            border: 0;
            width: 24px;
            height: 24px;
            filter: brightness(10);
        }

        .hamburger-menu .menu-icon.active {
            filter: none;
        }

        .hamburger-menu .menu-icon.active + span {
            color: #FF5D1C;
        }

        .hamburger-menu :global(.menu-item) {
            font-size: 16px;
            margin: 25px 0;
            width: 100%;
        }

        .hamburger-btn .notifications-count {
            top: 0;
            left: auto;
            right: -5px;
            transform: none;
        }

        .hamburger-menu .notifications-count {
            top: 50%;
            left: auto;
            right: 5px;
            margin-top: -10px;
            transform: none;
        }
    }
</style>
